import { requestAccountCertify } from "@/apis/account_api";

import router from "@/router";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  // new
  async REQUEST_ACCOUNT_CERTIFY({ commit }, parameter) {
    let param = {};
    try {
      commit("START_LOADING");
      const response = await requestAccountCertify(parameter);
      const { data } = response;
      if (data?.result !== "success") {
        param.result = false;
        return param;
      }
      if (data.accountInfo.result === 100) {
        param.result = true;
        param.name = data.accountInfo.accountName;
      } else {
        param.result = false;
      }

      commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      param.result = false;
    } finally {
      commit("END_LOADING");
    }
    return param;
  }
};

export default { mutations, state, actions, getters };
